var render = function render(){var _vm=this,_c=_vm._self._c;return _c('List',{staticClass:"survey-list",attrs:{"titleI18nKey":"admin.crm.survey.menu","no-head-btn":"","no-pagination":"","loading":_vm.loading,"listData":_vm.listData,"tableColumns":_vm.tableColumns},on:{"action":_vm.handleEdit}})
}
var staticRenderFns = []

export { render, staticRenderFns }